import { fetchBackend } from '@/utils/fetch'

/**
 * 通过 token 换取 access token
 * @param {string} token
 */
export const getSsoAccessToken = (token: string) =>
  fetchBackend.get('/pe/gatekeeper/v1/sso/authorize', {
    params: { token }
  })
